import { render } from "./rawMaterials.vue?vue&type=template&id=1e4ddef8&ts=true"
import script from "./rawMaterials.vue?vue&type=script&lang=ts"
export * from "./rawMaterials.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__